import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import FullPageLoginSpinner from 'router/actions/FullPageLoginSpinner'
import { logout } from 'state/Auth'
import { useEffectOnce } from 'utils'

export default function Logout() {
	const { t }    = useTranslation()
	const dispatch = useDispatch()
	const history  = useHistory()

	useEffectOnce(async () => {
		await dispatch(logout)
		history.replace('/login')
	})

	return <FullPageLoginSpinner text={t('Leaving...')}/>
}
